import type { TModalProps } from '~components/Modals/types';
import { Title } from '~components/Typography';
import { FeedbackCategory } from '~entities/feedback';
import { annals } from '~features/annals/hooks';
import { useTranslations } from '~i18n/hooks';
import { ReviewModal } from '~shared/ui/modals';
import { FeedbackForm } from '~widgets/FeedbackForm';

type Props = TModalProps;

export const Feedback = ({ open, onClose }: Props) => {
	const t = useTranslations('MySubscriptions');
	const trackSubmitFeedback =
		annals.subscription.useClickButtonSubmitFeedback();

	return (
		<ReviewModal
			title={
				<Title size="M" align="left">
					{t('feedbackTitle')}
				</Title>
			}
			subtitle={t('feedbackSubtitle')}
			open={open}
			locked={true}
			onClose={onClose}
			data-name="my-subscriptions-feedback-modal"
		>
			<FeedbackForm
				onClick={trackSubmitFeedback}
				onSubmit={onClose}
				category={FeedbackCategory.Subscription}
			/>
		</ReviewModal>
	);
};
